import React from 'react';
import { Document, Page, Text, StyleSheet } from '@react-pdf/renderer';
import { AboutSection, ExperienceSection, EducationSection, BadgeListSection } from './PdfSections';

const VARIANT_STYLES = {
    classic: { fontFamily: 'Times-Roman', fontSize: 10, padding: 34 },
    modern: { fontFamily: 'Helvetica', fontSize: 10, padding: 34 },
    compact: { fontFamily: 'Helvetica', fontSize: 9, padding: 24 },
};

function makeStyles(variant) {
    const v = VARIANT_STYLES[variant] || VARIANT_STYLES.classic;
    return StyleSheet.create({
        page: { padding: v.padding, fontSize: v.fontSize, fontFamily: v.fontFamily, lineHeight: 1.4 },
        name: { fontSize: v.fontSize + 8, fontWeight: 'bold', marginBottom: 2 },
        title: { fontSize: v.fontSize + 1, marginBottom: 4 },
        contact: { fontSize: v.fontSize - 1, color: '#333333', marginBottom: 2 },
    });
}

function ATSResumePdf({ variant = 'classic', ...props }) {
    const {
        name, about, email, address, phone, title,
        technicalSkills, softSkills, languages,
        educationData, jobData,
        linkedinURL, twitterURL, githubURL, websiteURL, showSocial,
    } = props;

    const styles = makeStyles(variant);
    const contactLine = [email, phone, address].filter(Boolean).join('   |   ');
    const socialLine = showSocial
        ? [linkedinURL, websiteURL, githubURL, twitterURL].filter(Boolean).join('   |   ')
        : '';

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <Text style={styles.name}>{name}</Text>
                {title ? <Text style={styles.title}>{title}</Text> : null}
                {contactLine ? <Text style={styles.contact}>{contactLine}</Text> : null}
                {socialLine ? <Text style={styles.contact}>{socialLine}</Text> : null}

                <AboutSection about={about} />
                <ExperienceSection jobData={jobData} />
                <EducationSection educationData={educationData} />
                <BadgeListSection title="Skills" items={technicalSkills} pillBg={null} />
                <BadgeListSection title="Additional Skills" items={softSkills} pillBg={null} />
                <BadgeListSection title="Languages" items={languages} pillBg={null} />
            </Page>
        </Document>
    );
}

export default ATSResumePdf;